<template>
    <div class="switch-container">
        <label class="switch">
            <input :id="elementId" v-model="checked" type="checkbox" />
            <span class="slider round" />
        </label>
        <label :for="elementId" style="margin-left: 10px">
            {{ label }}
            <slot />
        </label>
    </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, ref } from 'vue';
import { v4 } from 'uuid';

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
}>();

const props = defineProps<{
    value: boolean;
    id?: string;
    label?: string;
    disabled?: boolean;
}>();

const elementId = ref('');
const vmodel = ref(props.value);

onBeforeMount(() => {
    elementId.value = props.id || `checkbox-${v4()}`;
});

const checked = computed({
    get(): boolean {
        return vmodel.value;
    },
    set(value: boolean) {
        vmodel.value = value;
        emit('input', vmodel.value);
    }
});
</script>
<style scoped>
.switch-container {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 0.8rem;
}

.switch {
    position: relative;
    display: inline-block;
    width: 28px;
    height: 16px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: #7258e0;
}

input:focus + .slider {
    box-shadow: 0 0 1px #7258e0;
}

input:checked + .slider:before {
    -webkit-transform: translateX(12px);
    -ms-transform: translateX(12px);
    transform: translateX(12px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
